import { Component, ChangeDetectionStrategy } from "@angular/core";
import { FadeInOutTransition } from "@shared/transitions/fade-in-out.transition";

@Component({
    selector: "app-popup",
    templateUrl: "popup.component.html",
    styleUrls: ['./popup.component.scss'],
    animations: [
        FadeInOutTransition(0.9, 500, 500)
    ],
    host: {
        "[@fadeInOutTransition]": ""
    },
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: []
})
export class PopupComponent { }
